export type LanguageMeta = {
  code: string
  label: string
  short: string
  flag: string
}

const LANG_META: Record<string, Omit<LanguageMeta, 'code'>> = {
  ru: { label: 'Русский', short: 'RU', flag: 'ru' },
  rus: { label: 'Русский', short: 'RU', flag: 'ru' },
  en: { label: 'English', short: 'EN', flag: 'en' },
  eng: { label: 'English', short: 'EN', flag: 'en' },
  ua: { label: 'Українська', short: 'UA', flag: 'ua' },
  uk: { label: 'Українська', short: 'UA', flag: 'ua' },
  ukr: { label: 'Українська', short: 'UA', flag: 'ua' },
  kz: { label: 'Қазақша', short: 'KZ', flag: 'kz' },
  kk: { label: 'Қазақша', short: 'KZ', flag: 'kz' },
  kaz: { label: 'Қазақша', short: 'KZ', flag: 'kz' },
}

export function normalizeLangCode(code: string): string {
  const normalized = (code || 'ru').toLowerCase()
  if (normalized === 'rus') return 'ru'
  if (normalized === 'eng') return 'en'
  if (normalized === 'uk' || normalized === 'ukr') return 'ua'
  if (normalized === 'kk' || normalized === 'kaz' || normalized === 'kazakh') return 'kz'
  return normalized
}

export function getLanguageMeta(
  code: string,
  t?: (key: string) => string,
): LanguageMeta {
  const normalized = normalizeLangCode(code)
  const meta = LANG_META[normalized] ?? LANG_META[code.toLowerCase()]
  const fallbackLabel = meta?.label ?? normalized.toUpperCase()
  const short = meta?.short ?? normalized.toUpperCase().slice(0, 2)
  const flag = meta?.flag ?? normalized
  const translated = t?.(`app.languages.${normalized}`) ?? fallbackLabel
  const label =
    !translated ||
    translated === `app.languages.${normalized}` ||
    translated === normalized.toUpperCase() ||
    translated === code.toUpperCase()
      ? fallbackLabel
      : translated

  return { code: normalized, label, short, flag }
}
